import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { TabButton } from '~/components';
import { theme } from '~/styles/theme';
import { useSelector } from 'react-redux';
import * as S from './styles';
import ArbitrationBlock from '../ArbitrationBlock';
import ArbitrationAssistanceBlock from '../ArbitrationAssistanceBlock';

export default function ArbitrationSection({
  handleChangeReferee,
  optionSelected,
  referee,
  tabMode,
  selectedAssistant,
  setSelectedAssistant,
  selectedMatch,
}) {
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const styleTabDesktop = {
    primaryColor: match?.competitionId === 1 ? theme.coral : theme.turquoise,
    secondaryColor: theme.dark4,
    contrastColor: theme.white,
    textColor: theme.white,
  };

  const styleTabTablet = {
    primaryColor: match?.competitionId === 1 ? theme.coral : theme.turquoise,
    secondaryColor: theme.dark4,
    contrastColor: theme.white,
    textColor: theme.white,
  };

  const { t } = useTranslation();

  return (
    <S.ContainerArbitrationContent>
      <S.ArbitrationTabBar
        value={optionSelected}
        onChange={handleChangeReferee}
        styleTab={!tabMode ? styleTabDesktop : styleTabTablet}
      >
        <TabButton value={1} label={t('mainReferee')} />
        <TabButton value={2} label={t('arbitrationTeam')} />
      </S.ArbitrationTabBar>
      {!tabMode && (
        <>
          {Object.keys(referee).length > 0 && optionSelected === 1 && (
            <ArbitrationBlock
              name={referee.refereeName}
              avatar={referee.photoUrl}
              arbitrationCollege={referee.refereeSchool}
              matches={referee.seasonsGlobalStats}
              totalMatches={{ ...referee.acumulatedStats, season: 'TOTAL' }}
            />
          )}
          {optionSelected === 2 && (
            <ArbitrationAssistanceBlock
              selectedAssistant={selectedAssistant}
              setSelectedAssistant={setSelectedAssistant}
            />
          )}
        </>
      )}
      {tabMode && (
        <>
          {Object.keys(referee).length > 0 && optionSelected === 1 && (
            <ArbitrationBlock
              name={referee.refereeName}
              avatar={referee.photoUrl}
              arbitrationCollege={referee.refereeSchool}
              matches={referee.seasonsGlobalStats}
              totalMatches={{ ...referee.acumulatedStats, season: 'TOTAL' }}
              localStats={referee ? referee.homeTeamSeasonsStats : undefined}
              awayStats={referee ? referee.awayTeamSeasonsStats : undefined}
              selectedMatch={selectedMatch}
            />
          )}
          {optionSelected === 2 && (
            <ArbitrationAssistanceBlock
              selectedAssistant={selectedAssistant}
              setSelectedAssistant={setSelectedAssistant}
              tabMode
            />
          )}
        </>
      )}
    </S.ContainerArbitrationContent>
  );
}

ArbitrationSection.propTypes = {
  handleChangeReferee: PropTypes.func,
  optionSelected: PropTypes.number,
  referee: PropTypes.object,
  tabMode: PropTypes.bool,
  selectedAssistant: PropTypes.number,
  setSelectedAssistant: PropTypes.func,
  selectedMatch: PropTypes.object,
};

ArbitrationSection.defaultProps = {
  handleChangeReferee: () => {},
  optionSelected: 1,
  referee: {},
  tabMode: false,
  selectedAssistant: 0,
  setSelectedAssistant: () => {},
  selectedMatch: null,
};
